/**
 * @since 0.1.1
 */
import { z } from 'zod';

/**
 * @since 0.1.1
 * @category packagerOptsSchema
 */
export const packagerOptsSchema = z.record(z.any());
